var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAftereffects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3375"
    },
    d: "M40.824,52H11.176C5.003,52,0,46.997,0,40.824V11.176C0,5.003,5.003,0,11.176,0h29.649 C46.997,0,52,5.003,52,11.176v29.649C52,46.997,46.997,52,40.824,52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7ADFB"
    },
    d: "M27.44,39H24.2l-2.76-9.04h-8.32L10.48,39H7.36l8.24-28h3.32L27.44,39z M20.72,27l-3.48-11.36 L13.88,27H20.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7ADFB"
    },
    d: "M31.48,33.48c0,2.267,1.333,3.399,4,3.399c1.653,0,3.466-0.546,5.44-1.64L42,37.6 c-2.054,1.254-4.2,1.881-6.44,1.881c-4.64,0-6.96-1.946-6.96-5.841V25.44c0-2.16,0.673-3.841,2.02-5.04 c1.346-1.2,3.126-1.801,5.34-1.801s3.94,0.594,5.18,1.78c1.24,1.187,1.86,2.834,1.86,4.94V30.8L31.48,31.4V33.48z M40.08,28.24 v-3.08c0-1.413-0.44-2.42-1.32-3.021c-0.88-0.6-1.907-0.899-3.08-0.899c-1.174,0-2.167,0.359-2.98,1.08 c-0.814,0.72-1.22,1.773-1.22,3.16v3.199L40.08,28.24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAftereffects);
export default __webpack_public_path__ + "static/media/aftereffects.1aa825d0f9425d931e9d4d16b66e15ad.svg";
export { ForwardRef as ReactComponent };